"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleInfoText = exports.RectangleInfoHeader = exports.RectangleInfoContainer = exports.RectangleInfoColorText = exports.RectangleInfoBoldText = exports.RectangleCircle = exports.DataContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../assets/styles/colors");
const RectangleInfoContainer = styled_components_1.default.div `
  display: grid;
  position: absolute;
  left: -21.5px;
`;
exports.RectangleInfoContainer = RectangleInfoContainer;
const DataContainer = styled_components_1.default.div `
  background-color: ${colors_1.white};
  border: 1px solid ${(props) => props.$color};
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  font-weight: 400;
  padding: ${(props) => (props.$loading ? "0.1rem 0.5rem" : "1rem")};
  z-index: 20;
`;
exports.DataContainer = DataContainer;
const RectangleInfoHeader = styled_components_1.default.span `
  align-items: center;
  display: flex;
  gap: 5px;
  margin-bottom: ${(props) => (props.$loading ? "0.2rem" : "4px")};
`;
exports.RectangleInfoHeader = RectangleInfoHeader;
const RectangleCircle = styled_components_1.default.div `
  background-color: ${(props) => props.$color};
  border-radius: 50%;
  height: 1rem;
  width: 1rem;
`;
exports.RectangleCircle = RectangleCircle;
const RectangleInfoColorText = styled_components_1.default.span `
  color: ${(props) => props.$color};
`;
exports.RectangleInfoColorText = RectangleInfoColorText;
const RectangleInfoText = styled_components_1.default.span `
  display: flex;
  flex-direction: row;
  white-space: nowrap;
`;
exports.RectangleInfoText = RectangleInfoText;
const RectangleInfoBoldText = styled_components_1.default.span `
  color: ${colors_1.gray400};
  font-weight: 700;
  margin: 0rem 0.5rem 0rem 0rem;
  white-space: nowrap;
`;
exports.RectangleInfoBoldText = RectangleInfoBoldText;
